<template>
	<div class="xs-12">
		<!-- Tags -->
		<div class="flex wrap">
			<div
				class="flex xs-middle xs-between mr2 mt2 mb2 pl2 r2 fw4 lh125 c5 bg2 fs3"
				v-for="(item, i) in value"
				:key="i"
			>
				{{ item }}
				<!-- We force the tag 'resource' to be present, to differentiate from courses in Education -->
				<span
					v-if="item !== 'resource'"
					class="p2 cu2"
					@click.stop="removeTag(i)"
					>&times;</span
				>
				<span v-else class="p1" />
			</div>
		</div>

		<!-- Input new tag -->
		<j-base-input-text
			:placeholder="$t('categories_separated_by_commas')"
			v-if="canAdd"
			class="xs-12"
			v-model="newCategory"
			@blur="addOnBlur"
		/>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"

export default {
	name: "CategoriesList",
	data() {
		return {
			newCategory: null
		}
	},
	components: {
		JBaseInputText
	},
	props: {
		value: {
			required: true,
			default: () => [{ name: null, value: null }],
			validator(val) {
				return val === null || val instanceof Array
			}
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		canAdd: {
			type: Boolean,
			default: true
		}
	},

	methods: {
		// Remove from option based on array index
		removeTag(index) {
			let newValue = [...this.value]
			newValue.splice(index, 1)
			this.$emit("input", newValue)
		},
		addOnBlur() {
			if (this.newCategory && this.newCategory.length) {
				const newValue = this.newCategory.replace(",", "")
				this.newCategory = null
				if (!this.value.includes(newValue))
					this.$emit("input", [...this.value, newValue])
			}
		}
	},

	watch: {
		newCategory(newVal) {
			if (newVal && newVal.includes(",")) {
				const newValue = newVal.replace(",", "")
				this.newCategory = null
				if (!this.value.includes(newValue))
					this.$emit("input", [...this.value, newValue])
			}
		}
	}
}
</script>
